import { FC } from "react";
import { useTranslation } from "react-i18next";

import { CommonDefaultDrawer } from "../common-default-drawer";
import { BaseDrawer, FormFooter } from "../drawer";
import { CoursesCalendarRideProduceDrawerStyled } from "./drawer-courses-calendar-ride-produce.styled";
import {
  CoursesCalendarRideProducePreviewHint,
  CoursesCalendarRideProducePreviewTable,
  CoursesCalendarRideProduceProgress,
} from "./parts";
import {
  IUseDrawerCoursesCalendarRideProduceParams,
  useDrawerCoursesCalendarRideProduce,
} from "./use-drawer-courses-calendar-ride-produce";

export const DrawerCoursesCalendarRideProduce: FC<
  IUseDrawerCoursesCalendarRideProduceParams
> = props => {
  const { onCloseDrawer, drawerNumber } = props;
  const { t } = useTranslation();
  const {
    slots: previewSlots,
    slotsWithoutRide,
    selectedSlotIds,
    selectedCount,
    isWorking,
    progress,
    producePreviewHintKey,
    isSaveDisabled,
    showSequentialProgress,
    toggleSlotSelected,
    selectAllReadySlots,
    deselectAllReadySlots,
    onProduceClick,
  } = useDrawerCoursesCalendarRideProduce(props);

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <CommonDefaultDrawer
        onCloseDrawer={onCloseDrawer}
        title={t("course.calendar.producePreviewTitle")}
        Footer={
          <FormFooter
            onSaveClick={() => void onProduceClick()}
            onCancelClick={onCloseDrawer}
            saveLabel={t("general.PRODUCE")}
            isSaveDisabled={isSaveDisabled}
            isLoading={isWorking}
            cancelLabel={t("general.CANCEL")}
          />
        }
      >
        <CoursesCalendarRideProduceDrawerStyled>
          <CoursesCalendarRideProducePreviewHint
            hintKey={producePreviewHintKey}
            total={previewSlots.length}
            pending={selectedCount}
            skipped={previewSlots.length - slotsWithoutRide.length}
          />
          <CoursesCalendarRideProduceProgress
            show={showSequentialProgress}
            value={progress}
          />
          <CoursesCalendarRideProducePreviewTable
            slots={previewSlots}
            selectedSlotIds={selectedSlotIds}
            selectedCount={selectedCount}
            onToggleSelected={toggleSlotSelected}
            onSelectAllReady={selectAllReadySlots}
            onDeselectAllReady={deselectAllReadySlots}
          />
        </CoursesCalendarRideProduceDrawerStyled>
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
